<template>
  <div>
    <div v-if="sold">
      <span class="title d-block">
        {{ I18n.t("live_auctions.state.sold") }}
      </span>
      <span class="price price--highlight">
        {{ I18n.t("artworks.price", { price: formatPrice(auction.value) }) }}
      </span>
      <span class="price--with-commission">
        {{ I18n.t("artworks.price_with_commission", { price: formatPrice(auction.valueWithCommission) }) }}
      </span>
    </div>
    <div v-else-if="soldConditionally">
      <span class="title d-block">
        {{ I18n.t("live_auctions.state.conditionally") }}
      </span>
      <span class="price price--conditionally">
        {{ I18n.t("artworks.price", { price: formatPrice(auction.value) }) }}
      </span>
      <span class="price--with-commission">
        {{ I18n.t("artworks.price_with_commission", { price: formatPrice(auction.valueWithCommission) }) }}
      </span>
    </div>
    <span v-else class="title d-block mb-2">
      {{ I18n.t("live_auctions.state.unsold") }}
    </span>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import ComputeArtworkState from '@/shared/mixins/compute_artwork_state';
  import { formatNumber } from '@/shared/helpers';

  export default {
    name: 'ArtworkState',
    props: {
      artwork: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapGetters(['findAuction']),
      auction() {
        return this.findAuction(this.artwork.id);
      },
    },
    mixins: [ComputeArtworkState],
    created() {
      this.formatPrice = formatNumber;
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/modal/artwork_state.vue?91290488